import { CultivationCompanyContext } from '../context/CultivationCompanyContext'
import { useContext } from 'react'

export const useCultivationCompanyContext = () => {
  const context = useContext(CultivationCompanyContext)

  if (!context) {
    throw Error('useCultivationCompanyContext must be used inside an CultivationCompanyContextProvider')
  }

  return context
}